export const BASE_API_URL = process.env.REACT_APP_API_BASE_URL;
export const API_ROUTES = {
  ELIGIBILITY_CHECK: `${BASE_API_URL}/locations/search`,
  AVAILABILITY_CHECK: `${BASE_API_URL}/locations/availability_check`,
};
